import { PAEnvironment } from "../PA.Core/PAEnvironment";
import axios from 'axios';

import {
    isAnIScenarioPlannerServiceResponse,
    IScenarioCalcStatusResponse,
    IScenarioPlannerService,
    IScenarioPlannerServiceOptions,
    IScenarioPlannerServiceRequest,
    IScenarioPlannerServiceResponse,
    ScenarioPlannerCalcStatus
} from "./ScenarioPlannerService.IF";

export class ScenarioPlannerService
    implements
        IScenarioPlannerService
{

    Calculate(wbScnPlannerId: number, options?: IScenarioPlannerServiceOptions): Promise<IScenarioCalcStatusResponse> {
        const aCalculateRequest: IScenarioPlannerServiceRequest = {
            RequestType: "Calculate",
            RequestOptions: options || {},
            wbScnPlannerId: wbScnPlannerId
        };


        return this.makeRequest(aCalculateRequest)
    }

    CancelCalculate(wbScnPlannerId: number, options?: IScenarioPlannerServiceOptions): Promise<IScenarioCalcStatusResponse> {
        const aCalculateRequest: IScenarioPlannerServiceRequest = {
            RequestType: "Cancel",
            RequestOptions: options || {},
            wbScnPlannerId: wbScnPlannerId
        };

        return this.makeRequest(aCalculateRequest)
    }



    GetCalcStatus(wbScnPlannerId: number, options?: IScenarioPlannerServiceOptions):Promise<IScenarioCalcStatusResponse> {

        const aCalculateRequest: IScenarioPlannerServiceRequest = {
            RequestType: "GetStatus",
            RequestOptions: options || {},
            wbScnPlannerId: wbScnPlannerId
        };

        return this.makeRequest(aCalculateRequest)
    }



    private makeRequest(aRequest: IScenarioPlannerServiceRequest): Promise<IScenarioPlannerServiceResponse> {
        return new Promise<IScenarioPlannerServiceResponse>((resolve, error) => {
            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base), "/");
            if (sEndPoint.endsWith('/')) {
                sEndPoint += 'scenarioPlannerService';
            } else {
                sEndPoint += '/scenarioPlannerService';
            }

            axios.post(sEndPoint, {data: {request: aRequest}})
                .then((resp) => {
                    const responseData = resp.data;
                    if (!isAnIScenarioPlannerServiceResponse(responseData)) {
                        error(`Received unknown response format from ScenarioPlannerService: ${JSON.stringify(responseData)}`);
                        return;
                    }
                    resolve(responseData);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

}
